import * as React from "react"

import Seo from "../components/seo"
import Layout from "../components/layout"

const PrivacyPage = () => (
  <>
    <Layout>
    <Seo 
title="Privacy Policy" 
canonicalUrl="https://www.april-koa.com/privacy-policy/"
pathname="/privacy-policy/"
/>
      <div className="container py-16 max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Privacy Policy</h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">1. Introduction</h2>
          <p>
            Welcome to www.april-koa.com (“Website”, "Service", “we”, “our”, or "us"). We respect your privacy and are committed to protecting your personal information. This Privacy Policy outlines our practices concerning the collection, use, and sharing of your personal information.
          </p>
          <p className="mt-2">
            By visiting our Website and using our Service, you agree to the terms outlined in this policy.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">2. Information We Collect</h2>

          <h3 className="text-xl font-medium mt-4 mb-1">2.1. Personal Information</h3>
          <p>
            You may provide us with personal information including, but not limited to, your name, email address, phone number, and address.
          </p>

          <h3 className="text-xl font-medium mt-4 mb-1">2.2. Non-Personal Information</h3>
          <p>
            We may automatically collect non-personal information, such as IP addresses, browser type, and information about your interactions with our Website.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">3. How We Use Your Information</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Provide and maintain our Service.</li>
            <li>Improve user experience.</li>
            <li>Communicate with you, including newsletters, promotions, or updates.</li>
            <li>Comply with legal obligations.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">4. Cookies</h2>
          <p>
            We use cookies to collect website data and enhance user experience. By using our Website, you consent to our use of cookies.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">5. Third-Party Services</h2>
          <p>
            Our service may contain links to third-party websites. We are not responsible for the content or privacy practices of those websites.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">6. Security</h2>
          <p>
            We strive to maintain the safety of your personal information. However, no online transmission is 100% secure. While we work to protect your data, we cannot guarantee its absolute security.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">7. Your Rights</h2>
          <p>
            You have the right to access, modify, or delete your personal information. You can also opt-out of our newsletters at any time.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">8. Changes to the Privacy Policy</h2>
          <p>
            We may update our Privacy Policy periodically. The updated date will be reflected at the beginning of this policy.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-2">9. Contact Us</h2>
          <p>
            For any queries regarding this Privacy Policy, please contact us at{" "}
            <a href="mailto:info@april-koa.com" className="text-blue-600 underline">
              info@april-koa.com
            </a>.
          </p>
        </section>
      </div>
    </Layout>
  </>
)

export default PrivacyPage
